/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { BuildOutlined } from '@ant-design/icons';

import { BackButton } from '@/components/Buttons/BackButton';
import { CONFIG_BUILDER } from '@/config/embeddedApps';
import { useEmbeddedApp } from '@/hooks/useEmbeddedApp';
import { ConfigRevisionPageProps } from '@/pages/ConfigRevision/ConfigRevisionPage';
import { Container } from '@/primitives/Container';
import { Link } from '@/primitives/Link';
import { useMgmtPlaneStateStore } from '@/state/mgmtPlaneStore';
import { tokens } from '@/theme';

export default function BuildConfigRevisionPage({ nodeConfigId, configRevisionNumber }: ConfigRevisionPageProps) {
  const tenantId: string = useMgmtPlaneStateStore((state) => state.selectedTenantID) || '';

  const { iframeRef, iframeSrc } = useEmbeddedApp(CONFIG_BUILDER, {
    tenantId,
    configId: nodeConfigId,
    revisionId: `${configRevisionNumber}`,
  });
  const revisionPath = `/tenants/${tenantId}/node-configs/${nodeConfigId}/revisions/${configRevisionNumber}`;

  return (
    <Container full className="mimic-container">
      <BackButton to={`/tenants/${tenantId}/node-configs/${nodeConfigId}`} />
      <span>
        <BuildOutlined />
        <Link
          to={revisionPath}
          style={{
            marginLeft: '1rem',
            fontSize: '1.1875rem',
            fontFamily: 'DM Mono',
            color: tokens.color.text.textSubtle,
          }}
          dataTestId="config-revision-link"
        >
          Config Revision
        </Link>
      </span>
      <iframe
        ref={iframeRef}
        src={iframeSrc}
        allow="clipboard-read; clipboard-write; downloads"
        style={{
          width: '100%',
          height: '100%',
          flex: 1,
          border: 'none',
        }}
        title="Config Builder"
      />
    </Container>
  );
}
